import styled from "styled-components";
import React, {useEffect, useState} from "react";
import {
  CancelButton, ColSpan3, ColTitle,
  Input,
  RelativeDiv,
  RowSpan,
  Span4,
} from "../../assets/GlobalStyles";
import {useAtom} from "jotai";
import {ModalBody, ModalFooter, ModalHeader} from "../modal/Modal";
import {modalController} from "../../store";
import {adminInfoAtom} from "../../pages/platform_manage/entity/Admin";
import Select from "react-select";
import {updateAdmin} from "../../services/Platform/ManageAdminAxios";
import {toast} from "react-toastify";

const adminStatusOptions = [
  {value: 'NORMAL', label: '활성화'},
  {value: 'SUSPEND', label: '비활성화'}
]
export default function SelectAdminModal(props) {
  const {formType, title, onClick, buttonText, userId, data} = props;
  const [, setModal] = useAtom(modalController)
  useEffect(()=>{
    return ()=> {
      onClose()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  const onClose = () => {
    setModal({ isShow: false })
  }

  const handleModalComponent = () => {
    setModal({
      isShow: true,
      width: 900,
      modalComponent: () => {
        return (
          <SelectForm formType={formType} title={title} onSubmitProps={onClick} onClose={onClose} userId={userId} data={data}/>
        )
      }
    })
  }
  return (
      <Button type={'button'} data-admin-detail="true" onClick={handleModalComponent}>{buttonText}</Button>
  )
}

function SelectForm(props) {
  const { title, onSubmitProps, onClose, data } = props;
  const [adminInfoState, setAdminInfoState] = useState(adminInfoAtom)
  useEffect(()=>{
    setAdminInfoState(data);
  },[])

  const selectedStatus = adminInfoState?.status
      ?? (adminInfoState?.activeYn === 'N' ? 'SUSPEND' : 'NORMAL')
  const handleStatus = option => {
    setAdminInfoState({
      ...adminInfoState,
      status: option.value,
      activeYn: option.value === 'NORMAL' ? 'Y' : 'N'
    })
  }
  const handleSave = async () => {
    try {
      const response = await updateAdmin({
        ...adminInfoState,
        status: selectedStatus,
        activeYn: selectedStatus === 'NORMAL' ? 'Y' : 'N'
      })
      if (!response) {
        toast.error('관리자 정보 수정에 실패했습니다.')
        return
      }
      toast.success('관리자 사용 여부가 수정되었습니다.')
      if (typeof onSubmitProps === 'function') {
        onSubmitProps({
          ...adminInfoState,
          status: selectedStatus,
          activeYn: selectedStatus === 'NORMAL' ? 'Y' : 'N'
        })
      }
      onClose()
    } catch (error) {
      toast.error('관리자 정보 수정에 실패했습니다.')
    }
  }
  /**
   * 아이디 입력
   * @param event
   */
  const handleAdminId = (event) => {
        setAdminInfoState({
          ...adminInfoState,
          email: event.target.value
        })
      }
  /**
   * 패스워드 입력
   * @param event
   */
  const handlePassword = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      password: event.target.value
    })
  }

  /**
   * 패스원드 컨펌
   * @param event
   */
  const handleConfirmPassword = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      confirmPassword: event.target.value
    })
  }
  /**
   * 담당자명 입력
   * @param event
   */
  const handleManagerName = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      name: event.target.value
    })
  }
  /**
   * 담당자 연락처 입력
   * @param event
   */
  const handleManagerPhone = (event) => {
    setAdminInfoState({
      ...adminInfoState,
      phoneNumber: event.target.value
    })
  }

  return (
      <form onSubmit={(event) => {
        event.preventDefault()
        handleSave()
      }}>
        <ModalHeader title={title} />
        <ModalBody>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>아이디</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                      type={'text'}
                      placeholder={'이메일 형태 아이디를 입력해주세요'}
                      disabled
                      value={adminInfoState.email || ""}
                      onChange={(e) => handleAdminId(e)}
                  />
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자명</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                      type={'text'}
                      placeholder={'담당자 명을 입력해주세요'}
                      disabled
                      value={adminInfoState.name || ""}
                      onChange={(e) => handleManagerName(e)}
                  />
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>담당자 연락처</Span4></ColTitle>
                <RelativeDiv>
                  <Input
                      type={'text'}
                      placeholder={'연락처를 입력해주세요.'}
                      disabled
                      value={adminInfoState.phoneNumber || ""}
                      onChange={(e) => handleManagerPhone(e)}
                  />
                </RelativeDiv>
              </ColSpan3>
            </RowSpan>
            <RowSpan>
              <ColSpan3>
                <ColTitle><Span4>사용 여부</Span4></ColTitle>
                <StatusSelectWrap>
                  <Select
                      options={adminStatusOptions}
                      value={adminStatusOptions.find(option => option.value === selectedStatus)}
                      onChange={handleStatus}
                      styles={adminStatusSelectStyle}
                      isSearchable={false}
                      menuPosition="fixed"
                      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                  />
                  <StatusGuide>비활성화된 관리자는 로그인할 수 없습니다.</StatusGuide>
                </StatusSelectWrap>
              </ColSpan3>
            </RowSpan>
        </ModalBody>
        <ModalFooter style={{borderWidth: 0}}>
          <CancelButton type="button" onClick={onClose}>취소</CancelButton>
          <SaveButton type="submit">수정</SaveButton>
        </ModalFooter>
      </form>
  )
}

const Button = styled.button`
  width: 100%;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  background-color: transparent;

  &:hover {
    font-weight: bold;
  }
`
const StatusSelectWrap = styled.div`width:100%;`;
const StatusGuide = styled.p`margin:7px 0 0;color:#999;font-size:10px;`;
const SaveButton = styled.button`
  min-width:90px;height:40px;padding:0 16px;border:1px solid #f5811f;border-radius:6px;
  background:#fff4e8;color:#f5811f;font-size:11px;font-weight:700;cursor:pointer;
  &:hover{background:#ffe8d2;}
`;
const adminStatusSelectStyle = {
  control:(provided,state)=>({...provided,minHeight:42,height:42,borderColor:state.isFocused?'#f5811f':'#dfe3e6',borderRadius:8,background:'#fff',boxShadow:state.isFocused?'0 0 0 3px rgba(245,129,31,.13)':'none',fontSize:11,cursor:'pointer','&:hover':{borderColor:'#f1b786'}}),
  valueContainer:provided=>({...provided,height:42,padding:'0 12px'}),
  input:provided=>({...provided,margin:0,padding:0}),
  indicatorsContainer:provided=>({...provided,height:42}),
  indicatorSeparator:()=>({display:'none'}),
  dropdownIndicator:provided=>({...provided,padding:'0 10px',color:'#777'}),
  singleValue:provided=>({...provided,color:'#333',fontWeight:700}),
  menuPortal:provided=>({...provided,zIndex:9999}),
  option:(provided,state)=>({...provided,padding:'10px 12px',backgroundColor:state.isSelected?'#fff4e8':state.isFocused?'#fffaf6':'#fff',color:state.isSelected?'#d96500':'#555',fontSize:11,fontWeight:state.isSelected?700:500,cursor:'pointer'})
}
